<template>
  <v-layout row wrap my-3 mx-2>
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex xs12 md6 px-2>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Create a Form to Embed
        </v-card-title>
          <v-layout row wrap px-2 pt-2>
            <v-flex xs12 px-1>
              <v-text-field
                label="Form ID"
                readonly
                v-model="id"
                solo-inverted
                suffix="Form ID"
                disabled
                light
                class="tokenField"
                color="white"
                background-color="primary"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 px-1>
              Form Name
              <v-text-field
                label="Form Name"
                v-model="form.name"
                solo
              ></v-text-field>
            </v-flex>

            <v-flex xs12 px-1>
              Company Codes
              <v-autocomplete
                :items="company_codes"
                v-model="form.companycodes"
                label="Select company codes"
                return-object
                multiple
                @change="setOfferCC()"
                item-text="company_code"
                read-only
                solo
                clearable
                :loading="loading"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 px-1>
              Product
              <v-autocomplete 
                label="Product"
                v-model="form.product"
                solo
                item-value="key"
                item-text="name"
                return-object
                clearable
                :loading="productLoading"
                :items="productsShort"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox label="Fire Submit On Click" v-model="form.fireOnSubmit" :value="true"></v-checkbox>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox label="Online Payment" v-model="form.online_payment" :value="true"></v-checkbox>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox label="Only Online Payment" v-model="form.only_online_payment" :value="true"></v-checkbox>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox label="Single Page" v-model="form.single_page" :value="true"></v-checkbox>
            </v-flex>
            <v-flex xs4 px-1>
              <v-checkbox label="Require City" v-model="form.ask_city" :value="true"></v-checkbox>
            </v-flex>
            <v-flex xs12 px-1>
              <v-text-field
                label="Submit Button Payment Online English"
                solo
                v-model="form.submit_online_en"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 px-1 class="arFont">
              <v-text-field
                label="Submit Button Payment Online Arabic"
                solo
                class="arFont"
                style="direction:rtl;"
                v-model="form.submit_online_ar"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 px-1>
              <v-text-field
                label="Submit Button COD Payment English"
                solo
                v-model="form.submit_cod_en"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 px-1 class="arFont">
              <v-text-field
                label="Submit Button COD Payment Arabic"
                solo
                class="arFont"
                style="direction:rtl;"
                v-model="form.submit_cod_ar"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 px-1 pt-2 mb-4 class="elevation-1 grey lighten-2" v-if="productsShort.length>0">
              <v-layout row wrap>
                <v-flex xs12 pa-1 style="font-size:18px;font-weight:bold;">
                  Primary Radio Choices
                </v-flex>
                <v-flex xs12 pa-2 pb-1 mb-2 v-for="(o, i) in offers" :key="i" class="elevation-2 grey lighten-4">
                  <v-layout row wrap>
                    <v-flex xs12 pa-1>
                      <v-select
                        label="Text"
                        solo
                        hide-details
                        :items="(form.product && form.product.key) ? Object.values(products.filter(x=>x.key == form.product.key)[0].prices) : []"
                        item-text="name"
                        item-value="name"
                        v-model="o.price_name"
                        @change="getPrice(i, o.price_name)"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-text-field
                        label="Text"
                        hide-details
                        solo
                        v-model="o.text"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4 pl-1>
                      <v-text-field
                        label="Quantity"
                        hide-details
                        solo
                        v-model="o.quantity"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pl-1>
                      <v-text-field
                        label="Price"
                        hide-details
                        solo
                        readonly
                        v-model="o.price"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 pl-1>
                      <v-text-field
                        label="Online Payment Price"
                        hide-details
                        solo
                        background-color="grey lighten-4"
                        v-model="o.online_price"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 pl-1>
                      <v-text-field
                        label="COD Price total"
                        hide-details
                        solo
                        background-color="grey lighten-4"
                        v-model="o.offline_price"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 pa-1 v-if="form.product">
                      <v-autocomplete 
                        label="Varients"
                        v-model="o.vars"
                        solo
                        item-value="sku"
                        item-text="sku"
                        multiple
                        chips
                        clearable
                        :loading="productLoading"
                        :items="productsShortsku.filter(x=> x && x.includes(form.product.sku.slice(0, 9)))"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 pa-1 v-if="o && o.companycodes && o.companycodes.length">
                      <v-layout row wrap>
                        <v-flex xs12 pa-1>
                          <v-tabs
                            v-model="activeTab"
                            color="primary"
                            dark
                            slider-color="yellow"
                          >
                            <v-tab
                              v-for="(code, co) in o.companycodes.filter(x=>x)"
                              :key="'cc-' + co"
                              ripple
                            >
                              {{code.company_code}}
                            </v-tab>
                            <v-tab-item
                              v-for="(code, co) in o.companycodes.filter(x=>x)"
                              :key="'cc-' + co"
                              color="secondary"
                            >
                              <v-card flat color="primary">
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12 pb-1>
                                      <v-text-field
                                        name="Text"
                                        label="Text"
                                        solo
                                        hide-details
                                        v-model="code.text"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 py-1>
                                      <v-select
                                        label="Text"
                                        solo
                                        item-value="name"
                                        item-text="name"
                                        hide-details
                                        :items="(form.product && form.product.key) ? Object.values(products.filter(x=>x.key == form.product.key)[0].prices) : []"
                                        v-model="code.price_name"
                                        @change="getCOPriceBundels(i, co, code.price_name)"
                                      ></v-select>
                                    </v-flex>
                                    <v-flex xs6 pr-1 v-if="false">
                                      <v-text-field
                                        label="Price"
                                        hide-details
                                        solo
                                        v-model="code.price"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 py-1>
                                      <v-text-field
                                        label="Online Payment Price"
                                        hide-details
                                        solo
                                        background-color="grey lighten-4"
                                        v-model="code.online_price"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 py-1>
                                      <v-text-field
                                        label="COD Price total"
                                        hide-details
                                        solo
                                        background-color="grey lighten-4"
                                        v-model="code.offline_price"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                  
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4>
                      <v-btn 
                        @click="()=>{
                          offers.splice(i, 1)
                        }"
                        color="error">remove</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-btn color="primary" block 
                    @click="()=>{
                      offers.push({
                        text:'',
                        online_price:'',
                        price:'',
                        price_name:'',
                        quantity:offers.length + 1
                      })
                    }"
                    >add</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 px-1 pt-2 mb-4 class="elevation-1  grey lighten-2" v-if="form.companycodes && form.companycodes.length">
              <v-layout row wrap>
                <v-flex xs12 pa-1 style="font-size:18px;font-weight:bold;">
                  Delivery Fees
                </v-flex>
                <v-flex xs12 pa-2 pb-1 mb-2 class="elevation-2 grey lighten-4">
                  <v-tabs
                    v-model="activeTabDel"
                    color="primary"
                    dark
                    slider-color="yellow"
                  >
                    <v-tab
                      v-for="(code, co) in form.companycodes.filter(x=>x)"
                      :key="'cc-' + co"
                      ripple
                    >
                      {{code.company_code}}
                    </v-tab>
                    <v-tab-item
                      v-for="(code, co) in form.companycodes.filter(x=>x)"
                      :key="'cc-' + co"
                      color="secondary"
                    >
                      <v-card flat color="primary">
                        <v-layout row wrap pa-1>
                          <v-flex xs12 pa-1>
                            <v-autocomplete 
                              label="Product"
                              v-model="code.delivery"
                              solo
                              item-value="key"
                              item-text="name"
                              return-object
                              hide-details
                              clearable
                              :loading="productLoading"
                              :items="productsShort.filter(x=>x.name && x.name.includes('ees'))"
                            >
                            </v-autocomplete>
                            
                          </v-flex>
                          <v-flex xs6 pa-1 v-if="code.delivery&&code.delivery.key">
                            <v-select
                              label="Text"
                              solo
                              hide-details
                              item-value="name"
                              item-text="name"
                              :items="(code.delivery && code.delivery) ? Object.values(products.filter(x=>x.key == code.delivery.key)[0].prices) : []"
                              v-model="code.delivery_price_name"
                              @change="getDeliveryBundels(co, code.delivery_price_name)"
                            ></v-select>
                          </v-flex>
                          <v-flex xs6 pa-1>
                            <v-text-field
                              label="Price"
                              hide-details
                              solo
                              readonly
                              v-model="code.delivery_price"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 px-1 pt-2 mb-4 class="elevation-1  grey lighten-2" v-if="productsShort.length>0">
              <v-layout row wrap>
                <v-flex xs12 pa-1 style="font-size:18px;font-weight:bold;">
                  Items in offer
                </v-flex>
                <v-flex xs12 pa-2 pb-1 mb-2 v-for="(o, i) in bundels" :key="i" class="elevation-2 grey lighten-4">
                  <v-layout row wrap>
                    <v-flex xs12 pa-1>
                      <v-autocomplete 
                        label="Product"
                        v-model="o.product"
                        solo
                        item-value="key"
                        item-text="name"
                        return-object
                        clearable
                        :loading="productLoading"
                        :items="productsShort"
                      >
                      </v-autocomplete>
                      <span v-if="o.product">
                      </span>
                    </v-flex>
                    <v-flex xs12 v-for="(off, k) in o.offers" :key="'off-' + k" my-1 py-1  class="elevation-2 grey lighten-3">
                      <v-layout row wrap>
                        <v-flex xs12 pa-1>
                          <v-select
                            label="Text"
                            solo
                            hide-details
                            item-value="name"
                            item-text="name"

                            :items="(o.product && o.product.key)? Object.values(products.filter(x=>x.key == o.product.key)[0].prices) : []"
                            v-model="off.price_name"
                            @change="getPriceBundels(i, k, off.price_name)"
                          ></v-select>
                        </v-flex>
                        <v-flex xs4 pl-1>
                          <v-text-field
                            label="Quantity"
                            hide-details
                            solo
                            v-model="off.quantity"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4 pl-1>
                          <v-text-field
                            label="Price"
                            hide-details
                            solo
                            readonly
                            v-model="off.price"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4 pl-1>
                          <v-checkbox label="Varients" v-model="off.sizes" :value="true" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex xs12 pa-1 v-if="o.product">
                          <v-autocomplete 
                            label="Varients"
                            v-model="off.vars"
                            solo
                            item-value="sku"
                            item-text="sku"
                            multiple
                            chips
                            clearable
                            :loading="productLoading"
                            :items="productsShortsku.filter(x=> x && x.includes(o.product.sku.slice(0, 9)))"
                          >
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs4>
                          <v-btn  
                            @click="()=>{
                              bundels[i].offers.splice(k, 1)
                            }"
                            color="error">remove</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn color="primary" block 
                        @click="()=>{
                          bundels[i].offers.push({
                            text:'',
                            price:'',
                            price_name:'',
                            quantity: bundels[i].offers.length + 1
                          })
                        }"
                        >add offer</v-btn>
                    </v-flex>
                    
                    <v-flex xs4>
                      <v-btn  
                        @click="()=>{
                          bundels.splice(i, 1)
                        }"
                        color="error">remove product</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-btn color="primary" block 
                    @click="()=>{
                      bundels.push({
                        product:'',
                        offers:[]
                      })
                    }"
                    >add product</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 px-1>
              Campaign ID
              <v-autocomplete
                :items="campaignids"
                v-model="form.campaignid"
                label="Select a campaign"
                return-object
                solo
                clearable
                hide-details
                :loading="loading"
                :append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
                @click:append-outer="addCampaignD = true"
              ></v-autocomplete>
              <v-dialog v-model="addCampaignD" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">You want to add a Campaign?</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="New Campaign"
                          required
                          v-model="newCampaign"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="addCampaignD = false">Cancel</v-btn>
                    <v-btn :disabled="!newCampaign" color="green darken-1" flat @click="addCampaignID()">add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs12 px-1>
              Source
              <v-autocomplete
                :items="referrers"
                v-model="form.source"
                label="Select a source"
                return-object
                solo
                clearable
                hide-details
                :loading="loading"
                :append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
                @click:append-outer="addSourceD = true"
              ></v-autocomplete>
              <v-dialog v-model="addSourceD" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">You want to add a Source?</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Source"
                          required
                          v-model="newSource"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="addSourceD = false">Cancel</v-btn>
                    <v-btn :disabled="!newSource" color="green darken-1" flat @click="addSource()">add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs12 px-1>
              Company Code
              <v-autocomplete
                :items="companycodes"
                v-model="form.companycode"
                label="Select a company code"
                return-object
                read-only
                solo
                clearable
                hide-details
                :loading="loading"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 px-1>
              Facebook Pixel
              <v-autocomplete
                :items="facebookpixels"
                v-model="form.facebookpixel"
                label="Select a Facebook Pixel"
                return-object
                solo
                clearable
                hide-details
                :loading="loading"
                :append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
                @click:append-outer="addFB = true"
              ></v-autocomplete>
              <v-dialog v-model="addFB" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">You want to add a FACEBOOK Pixel?</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Pixel"
                          required
                          v-model="newFB"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="addFB = false">Cancel</v-btn>
                    <v-btn :disabled="!newFB" color="green darken-1" flat @click="addFBF()">add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs12 px-1>
              Snapchat Pixel
              <v-autocomplete
                :items="snapchatpixels"
                v-model="form.snapchatpixel"
                label="Select a Snapchat Pixel"
                return-object
                solo
                clearable
                :loading="loading"
                :append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
                @click:append-outer="addSC = true"
              ></v-autocomplete>
              <v-dialog v-model="addSC" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">You want to add a SNAPCHAT Pixel?</v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Pixel"
                          required
                          v-model="newSC"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="addSC = false">Cancel</v-btn>
                    <v-btn :disabled="!newSC" color="green darken-1" flat @click="addSCF()">add</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs12 px-1>
              <v-text-field
                label="Redirect to"
                solo
                v-model="form.redirect"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 px-1>
              <v-select
                :items="languages"
                v-model="language"
                solo
                label="Language"
              ></v-select>
            </v-flex>
            <v-flex xs12 px-1 py-1>
              <v-expansion-panel expand>
                <v-expansion-panel-content>
                  <div slot="header">CTA Title</div>
                  <v-card>
                    <v-card-text>
                      <vue-editor v-model="form.ctatitle"></vue-editor>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12 px-1 py-1>
              <v-expansion-panel expand>
                <v-expansion-panel-content>
                  <div slot="header">CTA Subtitle</div>
                  <v-card>
                    <v-card-text>
                      <vue-editor v-model="form.ctasubtitle"></vue-editor>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12 px-1 py-1>
              <v-expansion-panel expand>
                <v-expansion-panel-content>
                  <div slot="header">CTA Background</div>
                  <v-card>
                    <v-card-text>
                      <Swatches v-model="form.ctaBack" style="width: 100%" />
                      <Material v-model="form.ctaBack" class="mt-1" style="width: 105px;height: 105px;padding: 6px;"/>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12 px-1 py-1>
              <v-expansion-panel expand>
                <v-expansion-panel-content>
                  <div slot="header">Form Background - Dark:{{form.dark}}</div>
                  <v-card>
                    <v-card-text>
                      <Swatches @input="updateValue" v-model="form.formBack" style="width: 100%" />
                      <Material @input="updateValue" v-model="form.formBack" class="mt-1" style="width: 105px;height: 105px;padding: 6px;"/>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
          </v-layout>
          <v-card-actions class="px-3">
            <v-spacer></v-spacer>
            <v-btn 
              outline 
              color="error" 
              dark
              v-if="false"
              @click="dialog = true"
            >delete CTA</v-btn>
            <v-btn 
              @click="SaveForm()"  
              color="primary" 
              :loading="loading"
              dark>
              Generate & Save
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="390">
          <v-card>
            <v-card-title class="headline">Are You Sure?</v-card-title>
            <v-card-text>
              You , are you sure you want to do that?
              <div class="error white--text pa-2 ma-3">NOTE: </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" @click="DeleteDialog = false">cancel</v-btn>
              <v-btn 
                color="success" 
                outline 
                @click="()=>{ dialog = false  }"
              >confirm</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-flex>
    <v-flex xs12 md6  px-2 ref="container">
      <v-card
        class="pa-2 mb-5 elevation-6"
      >
        <v-card-title class="headline white--text primary" >
          Preview
          <v-spacer></v-spacer>
          <v-btn color="success" @click="loadPreview()">reload preview</v-btn>
          <v-btn color="success" @click="openForm()">open form</v-btn>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs10>
            <v-text-field
              label="Embed Code"
              v-model="shortLink"
              solo
              hide-details
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn
              v-clipboard:copy="shortLink"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              fab small outline color="primary" :disabled="!shortLink">
              <v-icon>file_copy</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 :class="`${language == 'ar' ? 'arChanges' : null}`">
            <div :gsid="id"></div>
          </v-flex>
          <v-flex xs12 :class="`${language == 'ar' ? 'arChanges' : null}`">
            <!-- <v-layout row wrap class="mx-0">
              <v-flex xs12 :class="`${form.dark? 'dark': null}`">
                <v-card  :color="form.formBack ? form.formBack.hex : 'white'" class="px-1">
                  <v-layout row wrap class="mx-0">
                    <v-flex xs12 class="text-xs-center">
                      <v-card :color="form.ctaBack ? form.ctaBack.hex : 'white'">
                        <v-card-text>
                          <v-layout row wrap class="mx-0">
                            <v-flex xs12 style="font-size: 1.4em;" 
                              :class="`${language == 'ar' ? 'arFont' : null}`"
                              v-html="form.ctatitle">
                            </v-flex>
                            <v-flex xs12 style="font-size: 1.2em;" 
                              :class="`${language == 'ar' ? 'arFont' : null}`"
                              v-html="form.ctasubtitle">
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 px-2>
                      <v-radio-group v-model="quantity">
                        <v-radio
                          v-for="o in offers"
                          :key="o.quantity"
                          :label="`${o.text}`"
                          :class="`${language == 'ar' ? 'arFont' : null}`"
                          :value="o"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12 px-2>
                      <v-text-field
                        :label="i18[language].fullname"
                        color="primary"
                        solo
                        :reverse="language == 'ar'"
                        :class="`${language == 'ar' ? 'arFont' : null}`"
                        v-model="fullname"
                        :error-messages="fullnameErrors"
                        @blur="$v.fullname.$touch()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12  px-2>
                      <v-autocomplete
                        :items="countries"
                        v-model="cc"
                        :label="i18[language].country"
                        solo
                        :reverse="language == 'ar'"
                        :class="`${language == 'ar' ? 'arFont' : null}`"
                        item-text="name"
                        item-value="alpha2Code"
                      >
                        <template slot-scope="{ item, selected }" slot="selection">
                          <v-chip
                            :selected="selected"
                            color="#efefef"
                            class="primary--text"
                          >
                            <v-avatar
                              size="avatarSize"
                              class="elevation-2"
                              color="#efefef"
                              v-if="language != 'ar'"
                            >
                              <img :src="`${item.flag}`" width="20px" >
                            </v-avatar>
                            <span class="font-weight-black">{{item.name}}</span>
                          </v-chip>
                        </template>
                        <template slot-scope="{item}" slot="item">
                          <v-list-tile-avatar
                            class="headline font-weight-light white--text"
                            color="white"
                          >
                            <img :src="`${item.flag}`">
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title class="font-weight-black" >{{item.name}}</v-list-tile-title>
                            <v-list-tile-sub-title 
                              v-text="item.name"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-icon>language</v-icon>
                          </v-list-tile-action>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs4 px-2 v-if="language != 'ar'">
                      <v-text-field
                        :label="i18[language].prefix"
                        color="primary"
                        solo
                        :class="`${language == 'ar' ? 'arFont' : null}`"
                        disabled
                        :reverse="language == 'ar'"
                        v-model="prefix"
                        :error-messages="prefixErrors"
                        @change="updatePrefix"
                        @blur="$v.prefix.$touch()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8  px-2>
                      <v-text-field
                        :label="i18[language].phone"
                        color="primary"
                        solo
                        :reverse="language == 'ar'"
                        :class="`${language == 'ar' ? 'arFont' : null}`"
                        v-model="phone"
                        :error-messages="phoneErrors"
                        @blur="$v.phone.$touch()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4 px-2 v-if="language == 'ar'">
                      <v-text-field
                        :label="i18[language].prefix"
                        color="primary"
                        solo
                        :class="`${language == 'ar' ? 'arFont' : null}`"
                        disabled
                        :reverse="language == 'ar'"
                        v-model="prefix"
                        :error-messages="prefixErrors"
                        @change="updatePrefix"
                        @blur="$v.prefix.$touch()"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-card-actions>
                    <v-btn block large color="primary"
                      :class="`${language == 'ar' ? 'arFont' : null}`"
                      @click.native="submitForm()">{{i18[language].submit}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout> -->
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios';
import { yervipUrl } from '@/config/urls';
import { uuid } from '@/customFunction';
import { storageRef, firebase, db, auth, store } from '@/fb';
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { required, minLength, maxLength, between, email, numeric, alpha } from 'vuelidate/lib/validators'
import { isEmail } from '@/validators'
import { VueEditor, Quill } from "vue2-editor";
import { Swatches } from 'vue-color'
import { Material } from 'vue-color'
import countriesJSON from '@/countries-ash.json'


let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};
let prefix, cc

export default {
  components:{VueEditor, Swatches, Material}, 
  data() {
    return {
      id:null,
      loading:false,
      languages:['en', 'ar'],
      dialog:false,
      frameStyle:null,
      wWidth:null,
      productLoading:false,
      selectedProduct:null,
      products:[],
      productsShort:[],
      productsShortsku:[],
      windowWidth:null, 
      shortLink:null,
      shortLinkCopy :null,
      longURL:null,
      ///////
      stepperValue:1,
      language:'ar',
      form:{
        ctatitle:`افضل عروضنا`,
        ctasubtitle:`اختر احد العروض التالية`,
        language:'ar',
        url:``,
        time:0,
        product:null,
        facebookpixel:``,
        formBack:{hex:'#ffffff'},
        ctaBack:{hex:'#ffffff'},
        dark:false,
        offers:[
        ],
        bundels:[
        ]
      },
      offers:[
      ],
      bundels:[
      ],
      i18:{
        en: {
          fullname :`Full Name`,
          prefix :`Country Code`,
          phone :`Phone`,
          start:`Start now`,
          country:`Country`,
          submit:`register and start`,
          required:`Required`,
          invalid_phone:`Please enter a valid phone number`
        },
        ar: {
          fullname :`الاسم`,
          prefix :`مفتاح الدولة`,
          phone :`الهاتف`,
          start:`ارسال الطلب`,
          country:`الدولة`,
          submit:`ارسال الطلب`,
          required:`مطلوب`,
          invalid_phone:`يرجى ادخال رقمك الصحيح`
        },
      },
      uid:null,
      fullname:null,
      prefix:null,
      quantity:1,
      phone:null,
      countries:[],
      location:{},
      cc:null,
      country_name:null,
      campaignids:[],
      addCampaignD:null,
      newCampaign:null,
      referrers:[],
      addSourceD:null,
      newSource:null,
      companycodes:[],
      company_codes:[],
      facebookpixels:[],
      addFB:null,
      newFB:null,
      snapchatpixels:[],
      addSC:null,
      newSC:null,
      activeTab:null,
      activeTabDel:null,
    }
  },
  props: {
    userName: {
      required: true,
      default: null
    },
    userImage: {
      required: true,
      default: ''
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
	},
  methods: {
    openForm() {
      window.open(yervipUrl(`form_preview/?id=${this.id}`), '_blank').blur();
      window.focus()
    },
    setOfferCC() {
      console.log('offers > CC', this.offers)
      for (let i = 0; i < this.offers.length; i++) {
        const element = this.offers[i];
        if(this.offers[i].companycodes) {
          let old = this.offers[i].companycodes.filter(x=>x).map(x=>x.company_code)
          console.log(old)
          console.log(this.form.companycodes.filter(x=>x).map(x=>x.company_code))
          let old_del = old.filter(x=> !this.form.companycodes.filter(x=>x).map(x=>x.company_code).includes(x))
          let m = this.form.companycodes.filter(x=> !old.includes(x.company_code)).map(x=>{ return {company_code:x.company_code, countries:x.countries, price:'', online_price:''}})[0]
          if(old_del.length) {
            this.offers[i].companycodes.filter(x=>x).splice( this.offers[i].companycodes.filter(x=>x).findIndex(x=> x.company_code == old_del[0]), 1)
            console.log('this.offers[i].companycodes', this.offers[i].companycodes.filter(x=>x))
          }
          this.offers[i].companycodes.push(m)
        } else {
          this.offers[i].companycodes = []
          let m = this.form.companycodes.filter(x=>x).map(x=>{ return {company_code:x.company_code, countries:x.countries, price:'', online_price:''}})
          this.offers[i].companycodes.push(...m)
        }
      }
      console.log(this.offers)
    },
    async loadCompanyCodes(){
      this.loading = true
      let a = await db.ref('settings/company_codes').once('value').then(x=>x.val())
      console.log(a)
      if(a){
        let b = Object.keys(a)
        this.company_codes = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i],
          }
        })
      }
      this.loading = false
    },
    addSource(){
			db.ref(`settings/dbfilters/referrers`).once('value').then(x=>{
				db.ref('settings/dbfilters/referrers').update({
					[x.val().length]:this.newSource
				})
				.then(x=>{
					this.addSourceD = false
					this.referrers.push(this.newSource)
					this.editCampaign.source = this.newSource
				})
			})
		},
		addCampaignID(){
			db.ref(`settings/dbfilters/campaigns`).once('value').then(x=>{
				db.ref('settings/dbfilters/campaigns').update({
					[x.val().length]:this.newCampaign
				})
				.then(x=>{
					this.addCampaignD = false
					this.campaignids.push(this.newCampaign)
					this.editCampaign.campaignid = this.newCampaign
				})
			})
		},
		addFBF(){
			db.ref('facebookpixels').push(this.newFB)
			.then(x=>{
				this.addFB = false
				this.facebookpixels.push(this.newFB)
				this.editCampaign.facebookpixel = this.newFB
			})
		},
		addSCF(){
			db.ref('snapchatpixels').push(this.newSC)
			.then(x=>{
				this.addSC = false
				this.snapchatpixels.push(this.newSC)
				this.editCampaign.snapchatpixel = this.newSC

			})
    },
    async getDBfilter(){
      this.campaignids = await db.ref(`settings/dbfilters/campaigns`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
      this.referrers = await db.ref(`settings/dbfilters/referrers`).once('value').then(x=>x.val())
			this.companycodes = await db.ref(`settings/dbfilters/companycodes`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
			this.languages = await db.ref(`languages`).once('value').then(x=>x.val().map(x=> x.name))
			let fb = await db.ref('facebookpixels').once('value').then(x=>x.val())
			for (const key in fb) {
				if (fb.hasOwnProperty(key)) {
					const p = fb[key];
					this.facebookpixels.push(p)
				}
			}
			let sc = await db.ref('snapchatpixels').once('value').then(x=>x.val())
			for (const key in sc) {
				if (sc.hasOwnProperty(key)) {
					const p = sc[key];
					this.snapchatpixels.push(p)
				}
			}
		},
    getPrice(i, key){
      console.log(this.products.filter(x=>x.key == this.form.product.key)[0][key])
      console.log(key)
      console.log(this.products.filter(x=>x.key == this.form.product.key)[0])
      this.offers[i].price = this.products.filter(x=>x.key == this.form.product.key)[0].prices.filter(x=>x.name == key)[0].value
    },
    getCOPriceBundels(i, co, key)
    {
      console.log(this.products.filter(x=>x.key == this.form.product.key)[0][key])
      console.log(key)
      console.log(this.products.filter(x=>x.key == this.form.product.key)[0])
      console.log(this.form)
      console.log(this.offers[i].companycodes[co])
      let c = this.offers[i].companycodes[co]
      c.price = this.products.filter(x=>x.key == this.form.product.key)[0].prices.filter(x=>x.name == key)[0].value
      this.offers[i].companycodes.splice(co, 1, c)
    },
    getDeliveryBundels(i, key){
      console.log(this.products.filter(x=>x.key == this.form.companycodes[i].delivery.key)[0][key])
      console.log(key)
      console.log(this.products.filter(x=>x.key == this.form.companycodes[i].delivery.key)[0])
      this.form.companycodes[i].delivery_price = this.products.filter(x=>x.key == this.form.companycodes[i].delivery.key)[0].prices.filter(x=>x.name == key)[0].value
    },
    getPriceBundels(i, k, key){
      console.log(this.products.filter(x=>x.key == this.bundels[i].product.key)[0][key])
      console.log(key)
      console.log(this.products.filter(x=>x.key == this.bundels[i].product.key)[0])
      this.bundels[i].offers[k].price = this.products.filter(x=>x.key == this.bundels[i].product.key)[0].prices.filter(x=>x.name == key)[0].value
    },
    async getProducts(){
      this.productLoading = true
      let a = await await db.ref(`productsCore`).once('value').then( x=>x.val())
      if(a){
        let k = Object.keys(a)
        let b = Object.values(a).map((x, i)=>{
          return {
            ...x,
            name:x.item_name,
            sku:x.sku,
            key:k[i]
          }
        })
        let c = Object.values(a).map((x, i)=>{
          return {
            name:x.item_name,
            sku:x.sku,
            key:k[i]
          }
        })
        this.products = b
        this.productsShortsku = c.map(x=>x.sku)
        this.productsShort = c
        console.log(this.productsShortsku)

        this.quantity = this.form.offers? this.form.offers[0]? this.form.offers[0] : {} : {}
      }
      this.productLoading = false
		},
    updatePrefix(){
      prefix = this.prefix
    },
    async getLocation(){
      let l = await axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=b9f2efa9e5b640cabf6b02568c63f895`).then(x=>x.data)
      this.location = l
      this.country_name = this.location.country_name
      this.prefix = this.location.calling_code
      prefix = this.location.calling_code
      this.cc = this.location.country_code2
      cc = this.cc
    },
    randomString(length, chars) {
      var mask = '';
      if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
      if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      if (chars.indexOf('#') > -1) mask += '0123456789';
      var result = '';
      for (var i = length; i > 0; --i) result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    },
    uuid(){
      let uuid = this.randomString(16, 'aA#')
      return uuid
    },
    async genUID(){
      this.uid = this.uuid()
    },
    async submitForm(){
      this.$v.$touch()
      console.log(this.$v.$invalid)
      if(!this.$v.$invalid) {
        let data = {
          fullname: this.fullname,
          phone: this.prefix + this.phone,
          country: this.country_name,
        }
        console.log(data)
      }
    },
    async getCountries(){
      let a = countriesJSON
      this.countries = a
    },
    genToken() {
      this.loading = true
      let vtoken = `GS_DB_${randomString(8, 'aA#')}`
      this.token = vtoken
      this.loading = false
      return vtoken
    },
    async SaveForm(){
      let data = {
        id:this.id,
        offers:this.offers,
        bundels:this.bundels,
        ...this.form
      }
      await store.collection("forms").doc(`${this.id}`).set(data);
      this.goTo('/form-embeds/')
      this.shortLink = `<script gsid="${this.id}" gslanguage="${this.language}" src="https://ashyaatform.web.app/masterembed.js">` + '<' + '/script>'
    },
    async loadForm(id){
      let a = await store.collection("forms").doc(`${this.id}`).get().then(x=>x.data())
      console.log(a)
      if(a) {
        this.form = a
        if(this.form.offers && this.form.offers.length) {
          let m = this.form.offers.filter(x=>x.companycodes)
          if(!m.length) {
            for (let i = 0; i < this.form.offers.length; i++) {
              this.form.offers[i].companycodes = []
            }
          }
        }
        console.log('this form', this.form)
        this.offers = this.form.offers ? this.form.offers : [{
          text:'',
          price:'',
          price_name:'',
          quantity:this.offers.length + 1,
          companycodes:[],
        }]
        this.bundels = this.form.bundels ? this.form.bundels : [{
          product:'',
          offers:[]
        }]
        this.shortLink = `<script gsid="${this.id}" gslanguage="${this.language}" src="https://ashyaatform.web.app/masterembed.js">` + '<' + '/script>'
        this.loadPreview()
      }
    },
    loadPreview(){
      (async function CreateGSDBMasterFormEmbed() {
        await sleep(3000)
        console.log('load id', this.id)
        function insertAfter(referenceNode, newNode) {
          referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
        }

        function insertBefore(newelement, referenceNode) { // this inserts DOM element before reference element
          referenceNode.parentNode.insertBefore(newelement, referenceNode);
        }
        let embededurl = document.querySelectorAll("[gsid='" + this.id +"']")//
        console.log(embededurl)
        for (var i = 0; i < embededurl.length; i++) {
          let target = embededurl[embededurl.length - 1]
          let container = document.createElement('div')
          container.setAttribute('style', 'width:100%')
          container.setAttribute('class', 'gsdbmasterform')
          let sCSS = ``
          let cssDiv = document.createElement('style')
          cssDiv.innerHTML = sCSS
          let loader = document.createElement('div')
          loader.setAttribute('id', 'DB-FORM')
          container.appendChild(loader)
          insertBefore(container, target)
          insertBefore(cssDiv, loader)
          //sleep(5000)
          let cssArray = [
            // 'https://ashyaatform.web.app/ashyaatdbmasterform-v.css',
            // 'https://ashyaatform.web.app/ashyaatdbmasterform.css',
            'https://fonts.googleapis.com/css?family=Material+Icons',
            'https://fonts.googleapis.com/css?family=Cairo&display=swap',
          ]
          cssArray.forEach(css => {
            let em = document.createElement('link')
            em.setAttribute('href', css)
            em.setAttribute('rel', 'stylesheet')
            em.setAttribute('scoped', 'true')
            insertBefore(em, loader)
          })
          let jsArray = [
            'https://ashyaatform.web.app/ashyaatdbmasterform-v.js',
            'https://ashyaatform.web.app/ashyaatdbmasterform.js',
            'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.js'
          ]
          jsArray.forEach(js => {
            let em = document.createElement('script')
            em.setAttribute('src', js)
            insertAfter(target, em)
          })
        }
      }).call(this);
    },
    goTo(path) {
      this.$router.push(path)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    updateValue(c){
      console.log(c)
      if(c.hsl.l < 0.65) {
        this.form.dark = true
      } else {
        this.form.dark = false
      }
    }
  },
  computed:{
    fullnameErrors () {
      const errors = []
      if (!this.$v.fullname.$dirty) return errors
      !this.$v.fullname.required && errors.push(this.i18[this.language].required)
      return errors
    },
    prefixErrors () {
      const errors = []
      if (!this.$v.prefix.$dirty) return errors
      !this.$v.prefix.required && errors.push(this.i18[this.language].required)
      return errors
    },
    phoneErrors () {
      const errors = []
      if (!this.$v.phone.$dirty) return errors
      !this.$v.phone.required && errors.push(this.i18[this.language].required)
      !this.$v.phone.phone_check && errors.push(this.i18[this.language].invalid_phone)
      return errors
    },

  },
  validations: {
    fullname: {
      required,
    },
    prefix: {
      required,
    },
    phone: {
      required,
      phone_check:async (phone)=> {
        prefix
        console.log(prefix)
        console.log(phone)
        if(!phone || !prefix) {
          return false
        }
        let m = await axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${parseInt(prefix)}${parseInt(phone)}&cc=${cc}`).then(d=>d.data)
        if(m.isPossibleNumber && m.isValidNumber && m.isValidNumberForRegion) {
            console.log(m)
            return true
        } else {
            return false
        }
      }
    },
  },
  watch: {
    language(){
      this.form.language = this.language
    },
    form(){
      console.log(this.form)
    },
    cc(){
      if(this.countries && this.countries.length > 0) {
        this.prefix = this.countries.filter(x=>x.alpha2Code == this.cc)[0].callingCodes[0]
      }
    },
    countries(){
      if(this.countries && this.countries.length > 0) {
        this.prefix = this.countries.filter(x=>x.alpha2Code == this.cc)[0].callingCodes[0]
      }
    },
    prefix(){
      prefix = this.prefix
    }
  },
  created() {
    this.loadCompanyCodes()
    this.getCountries()
    this.getLocation()
    this.genUID()
    this.getDBfilter()
    this.getProducts()
    if(this.$route.params.id) {
      this.id = this.$route.params.id
      this.loadForm(this.id);
      
		} else {
      this.id = this.genToken()
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.tokenField * {
  color:white !important;
}
.dark .v-messages__message {
  color:#fff !important;
}

.arChanges .arFont {
  font-family: 'Cairo', sans-serif !important;
  letter-spacing: unset !important;
}

.arChanges * {
  direction: rtl !important;
}
</style>
